export default "__VITE_ASSET__DPsERtCa__"